<template>
    <div class="l-listings">
        <div class="container">
            <div class="e-searchtop" v-if="showSearchResultsHeading && filters.keywords">
                <p>Showing results for: {{ filters.keywords }}</p>
            </div>
            <StoriesFilterButtons v-if="resultType === 'latestStories'" :story-types="storyTypes"  :activeFilter="activeFilter" @update:activeFilter="onFilterChange" />
            <div class="sidebar-grid" :class="{ 'sidebar-grid--silo-results': !hasSidebar }">
                <div class="m-filters sidebar-grid__filters flow-m">
                    <h2 class="text-scale-base text-dark-blue leading-base">Refine results</h2>
                    <search-filters @filters-loaded="onSearchFiltersLoaded"></search-filters>
                    <!-- <div class="sidebar-signposts">
                        <sidebar-signposts></sidebar-signposts>
                    </div> -->
                </div>
                <div class="sidebar-grid__results">
                    <div v-if="isLoading" class="loading-spinner">
                        <div class="spinner"></div>
                    </div>
                    <div v-else>
                        <div v-if="resultCount === 0">
                            <span class="e-noresults">
                                <p class="text-scale-small">
                                    <strong>Sorry, there are no results that match your selection, please refine your search.</strong>
                                </p>
                            </span>
                        </div>
                        <div v-else class="flow-m">
                            <div>
                                <h2 class="text-scale-base text-colour-lightest leading-base">Showing {{ resultsLoaded }} of {{ resultCount }} results</h2>
                                <div id="js-results-count" class="js-results-count" aria-live="assertive">
                                    <span class="visually-hidden">
                                        {{ resultCount }} results
                                        sorted by Updated (newest)
                                    </span>
                                </div>
                            </div>
                            <ol class="results-list" :data-featured-list="featureFirstTwoResults ? 'true' : 'false'">
                                <li 
                                    class="results-list__item" 
                                    v-for="searchResult in searchResults" 
                                    :key="searchResult.Id" 
                                    :class="{ 'staffmemberresult': searchResult.DocType == 'staffMember' }"
                                >
                                    <blog-list-item :result-item="searchResult" v-if="searchResult.DocType == 'blogArticle'" :hideImage="true"></blog-list-item>
                                    <events-list-item :result-item="searchResult" view="search" v-else-if="searchResult.DocType == 'event'" :hideImage="true"></events-list-item>
                                    <news-list-item
                                        :result-item="searchResult"
                                        v-else-if="searchResult.DocType == 'newsArticle'"
                                        :hide-image="true"
                                        :hide-tags-on-results="hideTagsOnResults"
                                    ></news-list-item>
                                    <property-list-item :result-item="searchResult" v-else-if="searchResult.DocType == 'property'" :hideImage="true"></property-list-item>
                                    <report-list-item :result-item="searchResult" v-else-if="searchResult.DocType == 'report'" :hideImage="true"></report-list-item>
                                    <staff-list-item :result-item="searchResult" :location-link="locationLink" v-else-if="searchResult.DocType == 'staffMember'" :hideImage="true"></staff-list-item>
                                    <support-list-item :result-item="searchResult" v-else-if="searchResult.DocType == 'product'" :hideImage="true"></support-list-item>
                                    <default-list-item :result-item="searchResult" :hideImage="true" v-else></default-list-item>
                                </li>
                            </ol>
                            <div>
                                <p class="text-colour-lightest"><strong>Showing {{ resultsLoaded }} of {{ resultCount }} results</strong></p>
                                <search-pager v-if="moreResultsAvailable"></search-pager>
                            </div>
                        </div>
                    </div>
                    <div v-if="error" class="error-message">
                        <p>Error fetching data</p>
                    </div>
                </div>
                <div class="sidebar-grid__signposts">
                    <sidebar-signposts></sidebar-signposts>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
    import DefaultListItem from '@/components/SiteSearch/default-list-item'
    import BlogListItem from '@/components/BlogSearch/blog-list-item'
    import EventsListItem from '@/components/EventSearch/events-list-item'
    import NewsListItem from '@/components/NewsSearch/news-list-item'
    import PropertyListItem from '@/components/PropertySearch/property-list-item'
    import ReportListItem from '@/components/ReportSearch/report-list-item'
    import SearchFilters from '@/components/SiteSearch/search-filters'
    import StoriesFilterButtons from '@/components/SiteSearch/search-stories-filters'
    import SearchPager from '@/components/SiteSearch/search-pager'
    import StaffListItem from '@/components/StaffSearch/staff-list-item'
    import SupportListItem from '@/components/SupportSearch/support-list-item'
    import SidebarSignposts from '@/components/SiteSearch/sidebar-signposts'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'

    export default {
        mounted() {
            const resultType = this.$el.dataset.resultType || 'default'
            this.resultType = resultType

            if (this.resultType) {
                this.search(true, this.resultType)
            }

            const storyTypesJson = this.$el.dataset.storyTypes
            if (storyTypesJson) {
                this.storyTypes = JSON.parse(storyTypesJson)
            }

            const ds = this.$el.dataset
            this.cmsShowDocumentTypeFilters = this.parseBool(ds.showDocumentTypeFilters)
            this.cmsShowUserKeywordFilter = this.parseBool(ds.showUserKeywordFilter)
            this.cmsShowUserDateFilter = this.parseBool(ds.showUserDateFilter)

        },

        components: {
            DefaultListItem,
            BlogListItem,
            EventsListItem,
            NewsListItem,
            PropertyListItem,
            ReportListItem,
            SearchFilters,
            StoriesFilterButtons,
            SearchPager,
            StaffListItem,
            SupportListItem,
            SidebarSignposts
        },

        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },

            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            moreResultsAvailable() {
                return this.$store.getters.moreResultsAvailable
            },

            featureFirstTwoResults() {
                return this.$store.getters.featureFirstTwoResults
            },

            hideTagsOnResults() {
                return this.$store.getters.hideTagsOnResults
            },

            resultsLoaded() {
                return this.$store.state.search.resultsLoaded
            },

            searchResults() {
                return this.$store.state.search.results
            },

            resultCount() {
                return this.$store.state.search.resultCount
            },

            pageCount() {
                return this.$store.state.search.pageCount
            },

            computedSearchApiUrl() {
                return this.searchApiUrl
            },

            hasSidebar() {
                return (
                    this.cmsShowDocumentTypeFilters ||
                    this.cmsShowUserKeywordFilter ||
                    this.cmsShowUserDateFilter ||
                    this.hasAvailableSearchFilters ||
                    this.hasSideBlocks
                )
            }
        },

        created() {
            this.hasSideBlocks = !!document.getElementById('side-blocks')

            // Listen for filter and page change events
            this.$eventHub.$on('search-filtersChanged', this.OnFiltersChanged)
            this.$eventHub.$on('search-pageChanged', this.OnPageChanged)

            this.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            this.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: false })

        },

        data() {
            return {
                resultType: null,
                activeFilter: '',
                searchApiUrl: '/umbraco/api/SearchApi/Search',
                storyTypes: [],
                cmsShowDocumentTypeFilters: false,
                cmsShowUserKeywordFilter: false,
                cmsShowUserDateFilter: false,
                hasAvailableSearchFilters: false,
                hasSideBlocks: false
            }
        },

        methods: {
            OnFiltersChanged() {
                this.search(true) // Trigger search when filters change, handled by searchMixin
            },

            OnPageChanged() {
                this.search() // Trigger search when page changes, handled by searchMixin
            },

            onStoriesFilterSelected() {
                this.search(true) // Trigger search when story filter is selected
            },

            onFilterChange(filter) {
                this.activeFilter = filter
            },

            onSearchFiltersLoaded(searchFilters) {
                this.hasAvailableSearchFilters = this.searchFiltersAreValid(searchFilters)
            },

            parseBool(v) {
                if (v === true) return true
                if (v == null) return false
                const s = String(v).trim().toLowerCase()
                return s === 'true' || s === '1' || s === 'yes'
            },

            searchFiltersAreValid(searchFilters) {
                if (!searchFilters) return false

                const filters = searchFilters.FilterList && searchFilters.FilterList.Filters
                const hasFilterList = filters && filters.length > 0

                return !!(searchFilters.ShowKeywordFilter || searchFilters.ShowDateFilter || hasFilterList)
            }
        },

        mixins: [globalMixin, searchMixin],

        props: {
            locationLink: {
                default: null,
                type: String
            },
 
            showSearchResultsHeading: {
                default: false,
                type: Boolean
            }
        }
    }
</script>
